import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

/**
 * BÃºsqueda de paÃ­ses (case-insensitive sobre nombre o cÃ³digo).
 * Devuelve hasta 50 resultados.
 */
export const searchCountries = async (q) => {
  const url = `${API_BASE_URL}/countries/search?q=${encodeURIComponent(q || '')}`;
  const res = await apiFetch(url, { headers: withTenant() });
  return res.json();
};

/**
 * Devuelve los paÃ­ses que tienen al menos un aeropuerto en la
 * DB del tenant. Usado en el formulario de Solicitudes AÃ©reas
 * para que el dropdown de PaÃ­s Origen/Destino muestre solo los
 * paÃ­ses donde el operador tiene cobertura aeroportuaria.
 *
 * Si el endpoint no existe o falla, hace fallback al search
 * genÃ©rico (para mantener compatibilidad con instalaciones que
 * no tengan este endpoint desplegado aÃºn).
 */
export const getCountriesWithAirports = async (q = '') => {
  try {
    const query = q ? `?q=${encodeURIComponent(q)}` : '';
    const res = await apiFetch(`${API_BASE_URL}/airports/countries${query}`, {
      headers: withTenant(),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json();
    if (json?.success && Array.isArray(json.data)) return json;
    throw new Error('Respuesta inesperada');
  } catch (e) {
    return { success: true, data: [] };
  }
};

/**
 * BÃºsqueda de clientes activos por razÃ³n social o NIT.
 */
export const searchClients = async (q) => {
  const url = `${API_BASE_URL}/clients/search?q=${encodeURIComponent(q || '')}`;
  const res = await apiFetch(url, { headers: withTenant() });
  return res.json();
};

/**
 * Aeropuertos filtrados por paÃ­s (y opcionalmente estado).
 */
export const getAirportsByPais = async (pais, estado = 'Activo') => {
  const url = `${API_BASE_URL}/airports/by-pais?pais=${encodeURIComponent(pais || '')}&estado=${encodeURIComponent(estado)}`;
  const res = await apiFetch(url, { headers: withTenant() });
  return res.json();
};

/**
 * Lista de usuarios asesores comerciales activos.
 */
export const getAsesores = async () => {
  const res = await apiFetch(`${API_BASE_URL}/users/asesores`, { headers: withTenant() });
  return res.json();
};

/**
 * Incoterms activos ordenados alfabÃ©ticamente (para combo del form).
 */
export const getActiveIncoterms = async () => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit: 200, offset: 1, query: { estado: 'Activo' }, sort: { codigo: 1 } }),
  });
  const json = await res.json();
  return json?.data || [];
};

/**
 * Tipos de mercancÃ­a activos (para combo de cada fila del detalle).
 */
export const getActiveCommodityTypes = async () => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit: 200, offset: 1, query: { estado: 'Activo' }, sort: { nombre: 1 } }),
  });
  const json = await res.json();
  return json?.data || [];
};
